const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)

export const validateEmail = (email: string): boolean => emailRegex.test(email)
